export const students = [
  {
    id: 1,
    name: "Jim",
    nickname: "Dale",
    age: 25,
    address: "Home",
    status: "Senior",
    univ: "MIT",
    job: "Dev",
  },
  {
    id: 2,
    name: "Ann",
    nickname: "Adkinson",
    age: 30,
    address: "Office",
    status: "Senior",
    univ: "InHa",
    job: "Mobile",
  },
  {
    id: 3,
    name: "Polly",
    nickname: "Dale",
    age: 25,
    address: "Home",
    status: "Junior",
    univ: "Cambridge",
    job: "Web",
  },
  {
    id: 4,
    name: "Kurt",
    nickname: "Jackson",
    age: 20,
    address: "London",
    status: "Middle",
    univ: "Oxword",
    job: "Software",
  },
  {
    id: 5,
    name: "John",
    nickname: "Dale",
    age: 40,
    address: "Arlando",
    status: "Senior",
    univ: "Oxword",
    job: "Dev",
  },
  {
    id: 6,
    name: "Bill",
    nickname: "Adkinson",
    age: 25,
    address: "Canada",
    status: "TeamLead",
    univ: "Cambridge",
    job: "Back",
  },
  {
    id: 7,
    name: "Jane",
    nickname: "Adkinson",
    age: 18,
    address: "Mexica",
    status: "TeamLead",
    univ: "Oxword",
    job: "Front",
  },
  {
    id: 8,
    name: "Ben",
    nickname: "Billson",
    age: 18,
    address: "America",
    status: "Senior",
    univ: "Cambridge",
    job: "IOS",
  },
];
